// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e5XC","label":"styles_label__1STic"};